<template>
  <v-app class="bg-color">
    <v-main>
      <v-container fluid grid-list-xs pt-5>
        <v-layout row wrap justify-center align-center>
          <v-flex xs11 lg11>
            <h2>
              <v-icon color="#077893" @click="Fn_BackIndex" size="38"
                >mdi-chevron-left</v-icon
              >
              {{ $t("dashboard.gconsentdetail") }}
            </h2>
          </v-flex>
        </v-layout>
        <v-layout
          row
          wrap
          justify-center
          align-center
          pt-5
          v-for="(item, index) in DataConsent"
          :key="index"
        >
          <v-flex xs11 lg11>
            <v-card class="rounded-lg">
              <v-card-title class="bg-card"
                >{{ $t("dashboard.cor") }}
                <v-spacer></v-spacer>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text class="mr-12">
                <v-layout row wrap ml-3 pa-1>
                  <v-flex xs11 lg11
                    ><b class="mr-2">{{ $t("dashboard.policy") }} :</b>
                    <a v-on:click="Fn_DetailPolicy">{{ item.PolicyHeader }} </a>
                    <br />
                    <div v-if="$t('default') === 'th'">
                      <b>{{ $t("dashboard.org") }} :</b>
                      {{ item.BusinessNameTh }}
                    </div>
                    <div v-else>
                      <b>{{ $t("dashboard.org") }} :</b>
                      {{ item.BusinessNameEng }}
                    </div>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex
            xs11
            lg11
            pt-5
            v-for="(i, index) in item.Consent"
            :key="index"
          >
            <v-card class="rounded-lg">
              <v-card-title primary-title>
                {{ index + 1 }}. {{ $t("consentform.head") }}
                <b class="ml-2">{{ i.ConsentHeader }}</b>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout row wrap ml-3 pa-1>
                  <v-flex xs11 lg11>
                    <div class="pb-2">
                      <b> {{ $t("dashboard.status") }} </b>
                      <b
                        v-if="i.Status === 'approve' || i.Status === 'ยินยอม'"
                        class="green--text"
                      >
                        {{ $t("dashboard.statusapp") }}</b
                      >
                      <b
                        v-else-if="
                          i.Status === 'unapprove' || i.Status === 'ปฏิเสธ'
                        "
                        class="red--text"
                      >
                        {{ $t("dashboard.statusreject") }}</b
                      >
                      <b v-else-if="i.Status === 'wait'" class="orange--text">
                        {{ $t("dashboard.statuspen") }}</b
                      >
                    </div>
                    <div class="pb-1">
                      <b>{{ $t("dashboard.detail") }}</b>
                    </div>
                    <div v-html="i.ConsentDetail"></div>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
      <div v-if="loadingDownloadData">
        <OverlaySearch />
      </div>
      <DialogGeneralConsent
        :show="DialogGeneral"
        :_detail="DataConsent"
        @closeDialogDelete="DialogGeneral = false"
      />
    </v-main>
  </v-app>
</template>

<script>
import DialogGeneralConsent from "@/components/dialog/DialogGeneralDashboardDetail.vue";
import OverlaySearch from "@/components/layouts/LoadingPage.vue";
import authorization from "@/functions/authorization.js";
import Swal2 from "sweetalert2/dist/sweetalert2.js";
import { mapGetters } from "vuex";

const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default {
  components: { DialogGeneralConsent, OverlaySearch },
  data: function () {
    return {
      DataConsent: [],
      DialogGeneral: false,
      loadingDownloadData: false,
      PolicyHeader: [],
    };
  },
  computed: {
    ...mapGetters(["DataGeneralConsent"]),
    ...mapGetters(["Business"]),
    ...mapGetters(["RoleAccount"]),
    _SendId: {
      get() {
        return this.DataGeneralConsent.SendId || "-";
      },
    },
    _Type: {
      get() {
        return this.DataGeneralConsent.Type || "-";
      },
    },
    _RoleAccount: {
      get() {
        return this.RoleAccount || "-";
      },
    },
  },
  mounted() {
    this.Fn_GetDataPolicy();
  },
  methods: {
    async Fn_GetDataPolicy() {
      this.loadingDownloadData = true;
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        SendId: this._SendId,
        Type: this._Type,
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "dashbord/GetConsentId",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            this.DataConsent = response.data.Message;
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title:
                this.$i18n.t("alert.contactserve") +
                error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: this.$i18n.t("alert.contactserve") + error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title:
                this.$i18n.t("alert.contactserve") + error.message || error,
            });
          }
        });
    },
    Fn_BackIndex() {
      this.$router.push("/search-consent-index");
    },
    Fn_DetailPolicy() {
      this.DialogGeneral = true;
    },
    // Fn_DownloadPdf() {
    //   this.loadingDownloadData = true;
    //   var payload = {
    //     UserName: this.$cookies.get("OneUsername"),
    //     AccountId: this.$cookies.get("OneAccountId"),
    //     BusinessNameEng: this.DataConsent[0].BusinessNameEng,
    //     BusinessNameTh: this.DataConsent[0].BusinessNameTh,
    //     Consent: this.DataConsent[0].Consent,
    //     ConsentId: this.DataConsent[0].ConsentId,
    //     Email: this.DataConsent[0].Email,
    //     GroupId: this.DataConsent[0].GroupId,
    //     GroupName: this.DataConsent[0].GroupName,
    //     Name: this.DataConsent[0].Name,
    //     PolicyDetail: this.DataConsent[0].PolicyDetail,
    //     PolicyHeader: this.DataConsent[0].PolicyHeader,
    //     PolicyId: this.DataConsent[0].PolicyId,
    //     SendId: this.DataConsent[0].SendId,
    //     SourceSystem: this.DataConsent[0].SourceSystem,
    //     Tel: this.DataConsent[0].Tel,
    //     Type: this.DataConsent[0].Type,
    //   };
    //   this.axios
    //     .post(
    //       process.env.VUE_APP_API_FACTORING_SERVICE + "report/gennerate/pdf",
    //       payload,
    //       { responseType: "arraybuffer" }
    //     )
    //     .then((response) => {
    //       let blob = new Blob([response.data], {
    //         type: "application/pdf",
    //       });
    //       var DateTime = new Date().toISOString().slice(0, 10)
    //       var link = document.createElement("a");
    //       link.href = window.URL.createObjectURL(blob);
    //       link.download = "GroupConsent" + DateTime + ".pdf";
    //       link.click();
    //       this.loadingDownloadData = false;

    //       //   if (response.data.Status === "OK") {
    //       //     let blob = new Blob([response.data], {
    //       //       type: "application/pdf",
    //       //     });
    //       //     let link = document.createElement("a");
    //       //     link.href = window.URL.createObjectURL(blob);
    //       //     link.download = "GeneralConsent.pdf";
    //       //     link.click();
    //       //   } else {
    //       //     Toast.fire({
    //       //       icon: "error",
    //       //       title: response.data.ErrorMessage,
    //       //     });
    //       //   }
    //       // })
    //       // .catch((error) => {
    //       //   this.loadingDownloadData = false;
    //       //   if (error.response) {
    //       //     Toast.fire({
    //       //       icon: "error",
    //       //       title: error.response.data.ErrorMessage,
    //       //     });
    //       //   } else if (error.request) {
    //       //     Toast.fire({
    //       //       icon: "error",
    //       //       title: error.request,
    //       //     });
    //       //   } else {
    //       //     Toast.fire({
    //       //       icon: "error",
    //       //       title: error.message || error,
    //       //     });
    //       //   }
    //     });
    // },
  },
};
</script>

<style>
td {
  border-style: hidden !important;
}
</style>

<style scoped>
.bg-color {
  background-color: #ddf7ff;
}

.bg-card {
  background-color: #eeeeee;
}
</style>
